import React from "react";

const Header = () => {
  return (
    <div className="flex p-2 align-items-center justify-content-between gap-2">
      <img
        alt="Saharanpur Nagar Nigam"
        src={require("assets/logos/snn-logo.png")}
        height="60"
        className="mr-2"
      />

      <h1 className="text-2xl text-primary text-center">
        Saharanpur Nagar Nigam
      </h1>

      <img
        alt="Government of UP"
        src={require("assets/logos/Seal_of_Uttar_Pradesh.svg").default}
        height="60"
        className="mr-2"
      />
    </div>
  );
};

export default Header;
